import React, { Fragment, useEffect } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { insertVehiculo, updateVehiculo } from '../../../redux/DucksUnidadInspeccion/VehiculosDuck'

const InspectoresFormComponent = (props) => {

    const dispatch = useDispatch()
    const vehiculoModify = props.vehiculoModify
    const [initialStateFormik, setInitialStateFormik] = React.useState({
        idautomovil: '',
        numero: '',
        marca: '',
        modelo: '',
        color: '',
        placas: ''
    })

    React.useState(() => {
        if (vehiculoModify !== null) {
            setInitialStateFormik({
                idautomovil: vehiculoModify.idautomovil,
                numero: vehiculoModify.numero,
                marca: vehiculoModify.marca,
                modelo: vehiculoModify.modelo,
                color: vehiculoModify.color,
                placas: vehiculoModify.placas
            })
        }
    }, [vehiculoModify])

    return (
        <Fragment>
            <Formik initialValues={initialStateFormik}
                validate={values => {
                    const errors = {};
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    if (vehiculoModify) {
                        const data = {
                            data: {
                                idautomovil: values.idautomovil,
                                numero: values.numero,
                                marca: values.marca,
                                modelo: values.modelo,
                                color: values.color,
                                placas: values.placas
                            }
                        }

                        dispatch(updateVehiculo(data))

                    } else {
                        const data = {
                            data: {
                                numero: values.numero,
                                marca: values.marca,
                                modelo: values.modelo,
                                color: values.color,
                                placas: values.placas
                            }
                        }
                        dispatch(insertVehiculo(data))
                    }
                    setSubmitting(false);
                    props.onClose()
                }}>
                {({ isSubmitting }) => (
                    <Form>
                        <h4 style={{ color: 'green' }}><strong>{
                            vehiculoModify ?
                                "Editar Vehiculo" :
                                "Agregar Vehiculo"
                        }</strong></h4><br />
                        <label htmlFor="numero">Número:</label><br />
                        <Field type="text" name="numero" className='form-control'>
                        </Field>
                        <ErrorMessage name="numero" component="div" /><br />

                        <label htmlFor="marca">Marca:</label><br />
                        <Field type="text" name="marca" className='form-control'>
                        </Field>
                        <ErrorMessage name="marca" component="div" /><br />

                        <label htmlFor="modelo">Modelo:</label><br />
                        <Field type="text" name="modelo" className='form-control'>
                        </Field>
                        <ErrorMessage name="modelo" component="div" /><br />

                        <label htmlFor="color">Color:</label><br />
                        <Field type="text" name="color" className='form-control'>
                        </Field>
                        <ErrorMessage name="color" component="div" /><br />

                        <label htmlFor="placas">Placas:</label><br />
                        <Field type="text" name="placas" className='form-control'>
                        </Field>
                        <ErrorMessage name="placas" component="div" /><br />

                        <div className='text-center'>
                            <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                {
                                    vehiculoModify ?
                                        "Guardar cambios" :
                                        "Agregar Vehiculo"
                                }
                            </button>
                        </div>


                    </Form>
                )}

            </Formik>

        </Fragment>
    )


}

export default withRouter(InspectoresFormComponent)